import React, { useEffect, useState } from "react";
import { MessageCircle, Phone, ArrowUp } from "lucide-react";
import { CONTACT } from "@/data/site";

export default function FloatingButtons() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed bottom-5 right-5 md:bottom-6 md:right-6 z-40 flex flex-col gap-3 items-end">
      <a
        data-testid="whatsapp-float-btn"
        href={`https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent("Hi Malviya Travel, I would like to know more about your tour packages.")}`}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat on WhatsApp"
        className="pulse-green w-13 h-13 md:w-14 md:h-14 rounded-full bg-[#25D366] hover:bg-[#1fb955] shadow-lg flex items-center justify-center text-white transition-all hover:scale-110"
        style={{ width: 56, height: 56 }}
      >
        <MessageCircle className="w-6 h-6" />
      </a>
      <a
        data-testid="call-float-btn"
        href={`tel:${CONTACT.phone.replace(/\s/g,'')}`}
        aria-label="Call Malviya Travel"
        className="pulse-b w-14 h-14 rounded-full bg-[#4DA8FF] hover:bg-[#2f95f2] shadow-lg flex items-center justify-center text-white transition-all hover:scale-110"
        style={{ width: 56, height: 56 }}
      >
        <Phone className="w-6 h-6" />
      </a>
      {showTop && (
        <button
          data-testid="back-to-top-btn"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="Back to top"
          className="w-12 h-12 rounded-full bg-[#0B3D91] hover:bg-[#082d6d] shadow-lg flex items-center justify-center text-white transition-all hover:scale-110"
        >
          <ArrowUp className="w-5 h-5" />
        </button>
      )}
    </div>
  );
}
